import {
    GET_MODULES_STRUCTURE_REQUEST_SUCCESS,
    GET_MODULES_STRUCTURE_REQUEST_FAILURE,
    FILTER_GROUP_MODULES,
    FILTER_GROUP_MODULES_WITHOUT_OPTIONS,
    SET_MODULE_OPTION,
    SET_ALL_FIELDS_PERMISSIONS_REQUEST,
    GET_GROUP_OPTIONS_PERMISSIONS_REQUEST,
    GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS,
    GET_GROUP_OPTIONS_PERMISSIONS_FAILURE,
    GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST,
} from '../constants/get_group_data.constants';

import {
    EDIT_GROUP_MODULE_PERMISSIONS_REQUEST,
    EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS,
    EDIT_GROUP_MODULE_PERMISSIONS_FAILURE,
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST,
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS,
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE,
} from '../constants/edit_group_data.constants';

import { proxy } from '../../components/statics';

const initialState = {
    loading: false,
    group_id: null,
    modules: [],
    filteredModule: null,
    moduleOption: '',
    moduleOptionFields: null,
    url_active: null,
    count: 1,
    error: null,
};

export const User_group_update = (state = initialState, action) => {
    switch (action.type) {
    case FILTER_GROUP_MODULES:
        return {
            ...state,
            filteredModule: state.modules.find(module => module.displayName === action.payload && module),
            url_active: null,
            loading: true,
        };

    case FILTER_GROUP_MODULES_WITHOUT_OPTIONS:
        return {
            ...state,
            loading: false,
        };

    case SET_MODULE_OPTION:
        return {
            ...state,
            moduleOption: proxy[action.payload],
            loading: true,
        };

    case GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST:
        return {
            ...state,
            url_active: action.payload,
            loading: false,
        };

    case GET_MODULES_STRUCTURE_REQUEST_SUCCESS:
        return {
            ...state,
            modules: action.payload.mergedData,
            group_id: action.payload.id,
            loading: false,
        };

    case GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS:
        return {
            ...state,
            moduleOptionFields: action.payload,
            loading: false,
        };

    case EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS:
        return {
            ...state,
            filteredModule: {
                ...state.filteredModule,
                modulePermissions: {
                    ...state.filteredModule.modulePermissions,
                    permissions: action.payload.permissions,
                },
            },
            loading: false,
        };

    case EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS:

        const new_data = { ...state.moduleOptionFields };

        Object.defineProperty(new_data, 'size', {
            writable: true,
            enumerable: false,
            value: state.moduleOptionFields.size,
        });

        if (action.payload.entity === 'model') {
            new_data[action.payload.url].modulesPermissions[action.payload.url] = action.payload.options;

            return {
                ...state,
                moduleOptionFields: new_data,
                loading: false,
            };
        } if (action.payload.entity === 'field') {
            new_data[action.payload.options.parent_entity_url].modulesPermissions[action.payload.url] = action.payload.options;

            return {
                ...state,
                moduleOptionFields: new_data,
                loading: false,
            };
        } if (action.entity === 'models') {
            for (const perm in action.payload) {
                if (action.payload.hasOwnProperty(perm)) {
                    const item = action.payload[perm];

                    item.entity === 'field'
                        ? new_data[item.parent_entity_url].modulesPermissions[item.url] = item
                        : new_data[item.url].modulesPermissions[item.url] = item;
                }
            }

            return {
                ...state,
                moduleOptionFields: new_data,
                loading: false,
            };
        }
        let data;
        return {
            ...state,
            moduleOptionFields: state.moduleOptionFields.map((permission, index) => {
                if (action.payload instanceof Array) data = action.payload[index];
                else data = action.payload;
                if (data.url === permission.URL) {
                    if (!permission.modulePermissions) {
                        permission.modulePermissions = {};
                        Object.assign(permission.modulePermissions, { permissions: data.permissions });
                    } else {
                        Object.assign(permission.modulePermissions, { permissions: data.permissions });
                    }
                }
                return permission;
            }),
            loading: false,
        };


    case 'COUNT_LOADING_ITEMS_START':
        return {
            ...state,
            count: state.count + 1,
        };

    case 'COUNT_LOADING_ITEMS_FINISH':
        return {
            ...state,
            count: 1,
        };

    case 'RESET_GROUP_UPDATE_MODULES':
        return {
            ...state,
            loading: false,
            group_id: null,
            modules: [],
            filteredModule: null,
            moduleOption: '',
            moduleOptionFields: null,
            url_active: null,
            count: 1,
        };

    case GET_GROUP_OPTIONS_PERMISSIONS_REQUEST:
    case EDIT_GROUP_MODULE_PERMISSIONS_REQUEST:
    case EDIT_GROUP_MODEL_PERMISSIONS_REQUEST:
    case SET_ALL_FIELDS_PERMISSIONS_REQUEST:
        return {
            ...state,
            loading: true,
        };

    case GET_MODULES_STRUCTURE_REQUEST_FAILURE:
    case EDIT_GROUP_MODULE_PERMISSIONS_FAILURE:
    case GET_GROUP_OPTIONS_PERMISSIONS_FAILURE:
    case EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE:
        return { ...state, loading: false, error: action.error };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/reducers/get_modules_structure.reducers.js